import styled from 'styled-components'
import React from 'react'

export const Hr = styled.hr`
  background-color: #d9d9d9;
  height: 1px;
  border: none;
`
